import { useDispatch, useSelector } from 'react-redux'
import { closeLogin } from '../../store/slices/ui.slice'
import { Modal } from './Modal'
import { Login } from '../../pagesv2/auth/Login'

export function LoginPopup() {
  const dispatch = useDispatch()
  const isOpen = useSelector((state) => state.ui.showLogin)

  if (!isOpen) return null

  const handleClose = () => {
    dispatch(closeLogin())
  }

  return (
    <Modal onClose={handleClose}>
      <Login onClose={handleClose} />
    </Modal>
  )
}
